import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { group_by_item_count } from '../../../../functions';

@Component({
  selector: 'app-home-partners-section',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, NgbCarouselModule],
  templateUrl: './home-partners-section.component.html',
})
export class HomePartnersSectionComponent {
  partnerSlider = {
    options: { showCaption: false },
    slides: [
      {
        title: 'LWV',
        image_url: 'assets/img/logo/partners/lwv.png',
        url: 'http://www.lwv.nl',
      },
      {
        title: 'ESZL',
        image_url: 'assets/img/logo/partners/eszl.png',
        url: 'https://www.eszl.nl',
      },
      {
        title: 'Keyport',
        image_url: 'assets/img/logo/partners/keyport.png',
        url: 'https://www.keyport.nl',
      },
      {
        title: 'Brightlands',
        image_url: 'assets/img/logo/partners/brightlands.png',
        url: 'https://www.brightlands.com',
      },
      {
        title: 'MKB Limburg',
        image_url: 'assets/img/logo/partners/mkblimburg.png',
        url: 'https://www.mkblimburg.nl',
      },
      {
        title: 'lltb',
        image_url: 'assets/img/logo/partners/lltb.png',
        url: 'https://www.lltb.nl',
      },
    ],
    slides_desktop: [] as any[],
    slides_mobile: [] as any[],
  };

  constructor() {
    this.partnerSlider.slides_desktop = group_by_item_count(this.partnerSlider.slides, 6);
    this.partnerSlider.slides_mobile = group_by_item_count(this.partnerSlider.slides, 2);
  }
}
